/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: bitacoraModalCtrl
* # alias: bit
*/
export default class bitacoraModalCtrl {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, $mdDialog, strategicTrackingListSrv, data, moment, $cookies, GlobalSrv, GlobalConfig) {
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.ngNotify = ngNotify;
		this.$mdDialog = $mdDialog;
		this.$cookies = $cookies;
		this.$stateParams = $stateParams;
		this.userinfo = null;
		this.moment = moment;
		this.showResponse = false;
		this.disabledButton = false
		this.totalData = data;
		this.gIndex = undefined;
		this.savingComment = false;
		this.comments = [];
		this.inResponse = [];
		this.responding = false;
		this.commentBitacora = '';
		this.commentToResponse = null;
		this.services = strategicTrackingListSrv;
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.GlobalSrv = GlobalSrv;
		this.GlobalConfig = GlobalConfig;
		this.notPicture = require('../../../../../images/unknown.png')

		this.optionsTextEditor = [
			['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
			['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'clear'],
			['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],,
			['insertImage','insertLink', 'html'],
			['undo', 'redo']
		]

		this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
			if (details !== undefined) {
				this.userinfo = details.user;
				this.userinfo.role_id = this.$cookies.get('hasRoleId');
				if (this.totalData.data !== undefined) {
					this.loadMore();
				} else {
					this.getEntries();
				}
			}
		});
	}

	close () {
		this.$mdDialog.hide();
	}

	response(comment, index) {
		this.responding = false;
		this.inResponse[index] = !this.inResponse[index];
		for (let i in this.inResponse) {
			if (this.inResponse[i]) {
				this.responding = true;
			}
		}
		this.commentToResponse = (this.responding) ? comment : null;
	}

	getNotify(idUser,isUserIdValue){
      this.getSendNotify(idUser, this.GlobalConfig.notificationType.inbox,isUserIdValue)
      this.getSendNotify(idUser, this.GlobalConfig.notificationType.email,isUserIdValue)
    }

    getSendNotify(idUser, notificationId,isUserIdValue){
      let post1 = {
          dsName: 'Notificación de comentario (Bitácora)',
          dsDescription: 'Señor profesor fue agregado un comentario en la bitácora de ' + this.totalData.title,
          idNotification_delivery_type: notificationId,
		  is_grouped: 1
      	}
      	if(isUserIdValue)
      		post1.idUser = idUser
      	else
      		post1.idTeacher = idUser
      this.GlobalSrv.sendNotification(post1)
    }

	save() {
		this.disabledButton = true
		let params = {
			entriesParents: (this.commentToResponse != null) ? this.commentToResponse.workplanActivityTypesEntriesId : null,
			workplanTeacherId: this.totalData.params.workplanTeacherId,
			activityTypeId: this.totalData.params.activityTypeId,
			description: this.commentBitacora.replace(/\u200B/g,''),
			userId: this.userinfo.id,
			rolCreatorId: this.userinfo.role_id,
		}
		
		this.savingComment = true;

		this.services.save.bitacora(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				if(this.totalData.params.userId)
					this.getNotify(this.totalData.params.userId,true)
				else if(this.totalData.params.teacherId)
					this.getNotify(this.totalData.params.teacherId,false)
				this.ngNotify.set('Registro guardado en bitácora', 'success');
				this.commentBitacora = '';
				this.savingComment = true;
				this.commentToResponse = null;
				this.getEntries();
			}
			this.disabledButton = false
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getEntries() {
		this.entries = null;
		this.totalData.data = [];
		this.services.get.entries(this.totalData.params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.totalData.data = response.data;
				this.gIndex = this.totalData.data.length-1;
				this.comments = [];
				this.loadMore();
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	loadMore() {
		if (this.totalData.data.length > 0) {
			this.gIndex = (this.gIndex === undefined) ? this.totalData.data.length-1 : this.gIndex;
			let initial = this.gIndex - 2;
			for (var i = this.gIndex; i >= 0; i--) {
				if (i < initial) {break;}
				this.comments.unshift(this.totalData.data[i]);
				this.gIndex--;
			}
		}
	}

}

bitacoraModalCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', '$mdDialog', 'strategicTrackingListSrv', 'data', 'moment', '$cookies','GlobalSrv','GlobalConfig'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModalCtrl.js